import { render, staticRenderFns } from "../views/menu.html?vue&type=template&id=02db22ca&"
import script from "../scripts/menu.ts?vue&type=script&lang=ts&"
export * from "../scripts/menu.ts?vue&type=script&lang=ts&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('02db22ca', component.options)
    } else {
      api.reload('02db22ca', component.options)
    }
    module.hot.accept("../views/menu.html?vue&type=template&id=02db22ca&", function () {
      api.rerender('02db22ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/menu.vue"
export default component.exports